import React, { FC, useEffect } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Button from '@mui/material/Button'
import VideoGallery from '../components/video/VideoGallery'
import { useAccount } from '../contexts/account'
import useRouter from '../hooks/useRouter'

const Landing: FC = () => {
  const { navigate } = useRouter()
  const { user, initialized } = useAccount()

  useEffect(() => {
    if (initialized && user) {
      navigate('admin-home')
    }
  }, [initialized, user])

  if (initialized && user) return null

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f5f5f5' }}>
      {/* Header Bar */}
      <Box sx={{ backgroundColor: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 3, py: 2 }}>
        <img src="/img/temp-logo.png" alt="Logo" width={180} />
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('login')}
          sx={{ px: 5, py: 1.5, fontSize: '1.1rem' }}
        >
          Sign In
        </Button>
      </Box>

      {/* Gallery */}
      <Box sx={{ flex: 1, py: 6 }}>
        <Container maxWidth="lg">
          <Typography variant="h4" sx={{ textAlign: 'center', mb: 5, fontWeight: 'bold' }}>
            Videos
          </Typography>
          <VideoGallery />
        </Container>
      </Box>

      {/* Footer */}
      <Box sx={{ backgroundColor: '#121212', py: 3, textAlign: 'center' }}>
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.4)' }}>
          &copy; {new Date().getFullYear()} Forum. All rights reserved.
        </Typography>
      </Box>
    </Box>
  )
}

export default Landing
